import {Grid} from '@primer/react-brand/esm'

import {
  MonaDivider as WebGLMonaDivider,
  type MonaDividerProps as WebGLMonaDividerProps,
} from '../../../../../brand/components/MonaDivider'

import Styles from './MonaDivider.module.css'

export interface MonaDividerProps {
  variant: WebGLMonaDividerProps['colorVariant']
  alt?: WebGLMonaDividerProps['alt']
}

export const defaultProps: Partial<MonaDividerProps> = {}

export const MonaDivider = (props: MonaDividerProps) => {
  const initializedProps: MonaDividerProps = {...defaultProps, ...props}
  const {variant, alt} = initializedProps

  return (
    <div className={Styles.MonaDivider}>
      <div className={Styles.MonaDivider__gridContent}>
        <Grid columnGap="none" rowGap="none" enableGutters={false}>
          <Grid.Column span={12} className={Styles.MonaDivider__gridColumn}>
            <WebGLMonaDivider colorVariant={variant} alt={alt} className={Styles.MonaDivider__artwork} />
          </Grid.Column>
        </Grid>
      </div>
    </div>
  )
}
